/* eslint-disable no-use-before-define */

import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { withStyles } from '@material-ui/core';
import { WarningTwoTone } from '@material-ui/icons';
import i18n from '../../i18n';
import IconLabel from '../IconLabel';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const PF2MAutocomplete = ({
  options,
  value,
  onChange,
  title,
  placeholder,
  classes,
  selectAllValue = -1,
  textFieldProps,
  ...props
}) => (
  <Autocomplete
    multiple
    id="checkboxes-tags-demo"
    options={[
      { value: selectAllValue, label: i18n.t('common:SelectAll') },
      ...options,
    ]}
    value={value}
    onChange={(e, val) => {
      if (val.length && val[val.length - 1].value === selectAllValue) {
        return onChange(e, options);
      }
      return onChange(e, val);
    }}
    disableCloseOnSelect
    getOptionLabel={option => option.label}
    getOptionSelected={(option, optionValue) => option.value === optionValue.value
          && !(option.value === selectAllValue)
    }
    size="small"
    renderOption={(option, { selected }) => (
      <React.Fragment>
        <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} />
        <IconLabel
          text={option.label}
          icon={(
            <WarningTwoTone
              fontSize="small"
              htmlColor="#FF9999"
            />
          )}
          condition={option.inactiveCondition}
          tooltip={option.tooltip}
        />
      </React.Fragment>
    )}
    style={{ width: 200 }}
    renderInput={params => (
      <TextField
        {...params}
        variant="outlined"
        label={title}
        placeholder={placeholder || title}
        {...textFieldProps}
      />
    )}
    classes={classes}
    {...props}
  />
);

PF2MAutocomplete.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  classes: PropTypes.object,
  selectAllValue: PropTypes.number,
  textFieldProps: PropTypes.object,
};
PF2MAutocomplete.defaultProps = {
  title: i18n.t('common:Select'),
  placeholder: i18n.t('common:Select'),
  selectAllValue: -1,
  classes: {},
  textFieldProps: {},
};

export default withStyles({
  inputRoot: { flexWrap: 'nowrap', overflow: 'hidden' },
  endAdornment: { backgroundColor: 'white', borderRadius: '20px' },
  paper: {},
})(PF2MAutocomplete);
